import styled from "styled-components";
import { TextField } from "@material-ui/core";
import { FormWrapper, OrangeAccentCard } from "../../styles/shared";

export const SalesWrapper = styled.div`
  background: #0a0e27;
  position: relative;
  margin: calc(-24px - 1.5rem - 4.375rem) -24px 0 -24px;
  padding-top: calc(4.375rem + 1.5rem);
  padding-bottom: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 4.375rem);
  max-height: calc(100vh - 1.375rem);
  height: 100vh;
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  padding: 0 16px 0 16px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  @media (min-width: 768px) {
    padding: 0 24px 0 24px;
  }
  
  @media (min-width: 992px) {
    padding: 0 48px 0 48px;
  }
  
  @media (min-width: 1400px) {
    padding: 0 72px 0 72px;
  }
  
  .row {
    position: relative;
    z-index: 2;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: stretch;
  }
`;

export const ProductsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  min-height: 0;
  position: relative;
  z-index: 1;
`;

export const SectionTitle = styled.div`
  color: #f29205;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  flex-shrink: 0;
  position: relative;
  z-index: 2;
  
  @media (min-width: 992px) {
    font-size: 18px;
    gap: 10px;
  }
  
  i {
    font-size: 18px;
    
    @media (min-width: 992px) {
      font-size: 20px;
    }
  }
`;

export const SearchCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 3;
  padding: 16px;
  flex-shrink: 0;
  
  @media (min-width: 992px) {
    padding: 20px;
  }
`;

export const SearchInput = styled(TextField)`
  .MuiOutlinedInput-root {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    color: #ffffff !important;
    
    fieldset {
      border-color: rgba(255, 255, 255, 0.1);
      border-width: 2px;
    }
    
    &:hover fieldset {
      border-color: rgba(0, 212, 255, 0.3);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 0.08);
      
      fieldset {
        border-color: #00d4ff;
        border-width: 2px;
      }
    }
    
    .MuiInputBase-input {
      color: #ffffff !important;
      font-family: 'Nunito', Helvetica, Sans-Serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      
      @media (min-width: 992px) {
        font-size: 16px !important;
      }
    }
  }
  
  .MuiInputLabel-root {
    color: #b0b0b0 !important;
    
    &.Mui-focused {
      color: #00d4ff !important;
    }
  }
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px;
  min-height: 0;
  max-height: 100%;
  align-items: start;
  position: relative;
  z-index: 0;
  margin-top: 50px;

  @media (min-width: 576px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 12px;
  }
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
    padding: 8px;
    margin-top: 6px;
  }
  
  @media (min-width: 992px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
  }
  
  @media (min-width: 1400px) {
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
  }
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(242, 146, 5, 0.5);
    border-radius: 10px;
    
    &:hover {
      background: rgba(242, 146, 5, 0.7);
    }
  }
`;

export const ProductCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 6px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-self: start;
  
  @media (min-width: 576px) {
    padding: 7px;
    gap: 5px;
  }
  
  @media (min-width: 768px) {
    border-radius: 10px;
    padding: 10px;
    gap: 8px;
  }
  
  @media (min-width: 992px) {
    padding: 12px;
    gap: 10px;
  }
  
  &:hover:not([data-disabled="true"]) {
    background: rgba(255, 255, 255, 0.08);
    border-color: #f29205;
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(242, 146, 5, 0.2);
  }
  
  &[data-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.6;
    
    &:hover {
      transform: none;
    }
  }
  
  &[data-added="true"] {
    animation: productAdded 0.6s ease-out;
    border-color: #00d4ff !important;
    background: rgba(0, 212, 255, 0.15) !important;
    box-shadow: 0 0 20px rgba(0, 212, 255, 0.4) !important;
  }
  
  @keyframes productAdded {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 rgba(0, 212, 255, 0);
    }
    50% {
      transform: scale(1.05);
      box-shadow: 0 0 25px rgba(0, 212, 255, 0.6);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 rgba(0, 212, 255, 0);
    }
  }
`;

export const ProductImage = styled.div`
  width: 100%;
  height: 60px;
  min-height: 60px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  
  @media (min-width: 768px) {
    height: 70px;
    min-height: 70px;
    border-radius: 7px;
  }
  
  @media (min-width: 992px) {
    height: 75px;
    min-height: 75px;
    border-radius: 8px;
  }
  
  @media (min-width: 1400px) {
    height: 80px;
    min-height: 80px;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  
  i, svg {
    font-size: 28px;
    color: rgba(255, 255, 255, 0.3);
    
    @media (min-width: 768px) {
      font-size: 30px;
    }
    
    @media (min-width: 992px) {
      font-size: 32px;
    }
    
    @media (min-width: 1400px) {
      font-size: 36px;
    }
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-height: 0;
  
  @media (min-width: 576px) {
    gap: 4px;
  }
  
  @media (min-width: 768px) {
    gap: 5px;
  }
  
  @media (min-width: 992px) {
    gap: 6px;
  }
`;

export const ProductName = styled.h4`
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  margin: 0;
  line-height: 1.3;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 1.35;
  }
  
  @media (min-width: 992px) {
    font-size: 15px;
    line-height: 1.4;
  }
  
  @media (min-width: 1400px) {
    font-size: 16px;
  }
`;

export const ProductBrandStock = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  color: #b0b0b0;
  font-size: 10px;
  line-height: 1.1;
  flex-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  
  @media (min-width: 576px) {
    gap: 3px;
    line-height: 1.15;
  }
  
  @media (min-width: 768px) {
    font-size: 11px;
    gap: 4px;
    line-height: 1.2;
  }
  
  @media (min-width: 992px) {
    font-size: 12px;
    gap: 6px;
    line-height: 1.25;
  }
  
  @media (min-width: 1400px) {
    font-size: 13px;
    gap: 8px;
    line-height: 1.3;
  }
  
  span:first-child {
    color: #b0b0b0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 60%;
    font-size: inherit;
  }
  
  .separator {
    color: rgba(255, 255, 255, 0.3);
    margin: 0 2px;
    flex-shrink: 0;
    
    @media (min-width: 768px) {
      margin: 0 3px;
    }
    
    @media (min-width: 992px) {
      margin: 0 4px;
    }
  }
`;

export const ProductStock = styled.span`
  color: #b0b0b0;
  font-size: inherit;
  font-weight: 500;
  
  &.low-stock {
    color: #b0b0b0;
  }
  
  &.out-of-stock {
    color: #ff4444;
  }
`;

export const ProductPrice = styled.div`
  color: #f29205;
  font-size: 16px;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  line-height: 1.1;
  letter-spacing: 0.3px;
  margin: 0;
  
  @media (min-width: 576px) {
    line-height: 1.15;
  }
  
  @media (min-width: 768px) {
    font-size: 17px;
    line-height: 1.2;
  }
  
  @media (min-width: 992px) {
    font-size: 18px;
  }
  
  @media (min-width: 1400px) {
    font-size: 20px;
  }
`;

export const AddButton = styled.button`
  background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
  border: none;
  color: #ffffff;
  padding: 6px 10px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  margin-top: auto;
  
  @media (min-width: 576px) {
    padding: 7px 11px;
    font-size: 12px;
  }
  
  @media (min-width: 768px) {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
    gap: 6px;
  }
  
  @media (min-width: 992px) {
    padding: 9px 14px;
    border-radius: 7px;
    font-size: 13px;
    gap: 7px;
  }
  
  @media (min-width: 1400px) {
    padding: 10px 16px;
    border-radius: 8px;
    font-size: 14px;
    gap: 8px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(242, 146, 5, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
  
  svg {
    font-size: 11px;
    
    @media (min-width: 576px) {
      font-size: 12px;
    }
    
    @media (min-width: 768px) {
      font-size: 12px;
    }
    
    @media (min-width: 992px) {
      font-size: 13px;
    }
    
    @media (min-width: 1400px) {
      font-size: 14px;
    }
  }
`;

export const CartSection = styled.div`
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
`;

export const CartCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  padding: 0;
  overflow: hidden;
  min-height: 0;
`;

export const CartHeader = styled.div`
  padding: 10px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  
  @media (min-width: 768px) {
    padding: 12px 14px;
  }
  
  @media (min-width: 992px) {
    padding: 14px 16px;
  }
  
  &[data-pulse="true"] {
    animation: cartPulse 0.6s ease-out;
    background: rgba(0, 212, 255, 0.1);
    border-bottom-color: #00d4ff;
  }
  
  @keyframes cartPulse {
    0% {
      background: rgba(0, 212, 255, 0);
      transform: scale(1);
    }
    50% {
      background: rgba(0, 212, 255, 0.15);
      transform: scale(1.02);
    }
    100% {
      background: rgba(0, 212, 255, 0);
      transform: scale(1);
    }
  }
  
  h3 {
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    
    @media (min-width: 768px) {
      font-size: 17px;
      gap: 7px;
    }
    
    @media (min-width: 992px) {
      font-size: 18px;
      gap: 8px;
    }
    
    svg {
      color: #f29205;
      font-size: 18px;
      
      @media (min-width: 768px) {
        font-size: 19px;
      }
      
      @media (min-width: 992px) {
        font-size: 20px;
      }
    }
  }
`;

export const ClearCartButton = styled.button`
  background: rgba(255, 68, 68, 0.2);
  border: 2px solid #ff4444;
  color: #ff4444;
  padding: 4px 8px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
  line-height: 1;
  
  @media (min-width: 768px) {
    padding: 5px 9px;
    height: 26px;
    border-radius: 5px;
    font-size: 11px;
    gap: 5px;
  }
  
  @media (min-width: 992px) {
    padding: 5px 10px;
    height: 28px;
    font-size: 12px;
  }
  
  svg {
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    @media (min-width: 768px) {
      font-size: 11px;
    }
    
    @media (min-width: 992px) {
      font-size: 11px;
    }
  }
  
  &:hover:not(:disabled) {
    background: rgba(255, 68, 68, 0.3);
    transform: translateY(-1px);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const CartItems = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 0;
  
  @media (min-width: 768px) {
    padding: 8px;
    gap: 5px;
  }
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(242, 146, 5, 0.5);
    border-radius: 10px;
    
    &:hover {
      background: rgba(242, 146, 5, 0.7);
    }
  }
`;

export const CartItem = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  
  @media (min-width: 768px) {
    padding: 5px 7px;
    border-radius: 6px;
  }
  
  @media (min-width: 992px) {
    padding: 6px 8px;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: #f29205;
  }
`;

export const ItemInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  
  @media (min-width: 768px) {
    gap: 3px;
  }
`;

export const ItemName = styled.h4`
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  @media (min-width: 768px) {
    font-size: 12px;
  }
  
  @media (min-width: 992px) {
    font-size: 12px;
  }
`;

export const ItemDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  
  @media (min-width: 768px) {
    gap: 8px;
  }
`;

export const ItemQuantity = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  
  span {
    color: #ffffff;
    font-size: 11px;
    font-weight: 600;
    min-width: 16px;
    text-align: center;
    
    @media (min-width: 768px) {
      font-size: 11px;
      min-width: 18px;
    }
    
    @media (min-width: 992px) {
      font-size: 12px;
      min-width: 20px;
    }
  }
`;

export const QuantityButton = styled.button`
  background: rgba(242, 146, 5, 0.2);
  border: 1px solid #f29205;
  color: #f29205;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 10px;
  padding: 0;
  flex-shrink: 0;
  
  @media (min-width: 768px) {
    width: 22px;
    height: 22px;
    font-size: 11px;
  }
  
  @media (min-width: 992px) {
    width: 24px;
    height: 24px;
    border-radius: 5px;
  }
  
  svg {
    font-size: 10px;
    
    @media (min-width: 768px) {
      font-size: 11px;
    }
    
    @media (min-width: 992px) {
      font-size: 12px;
    }
  }
  
  &:hover {
    background: rgba(242, 146, 5, 0.3);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const ItemTotal = styled.div`
  color: #f29205;
  font-size: 11px;
  font-weight: 700;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);
  white-space: nowrap;
  flex-shrink: 0;
  
  @media (min-width: 768px) {
    font-size: 12px;
  }
  
  @media (min-width: 992px) {
    font-size: 13px;
  }
`;

export const RemoveButton = styled.button`
  background: rgba(255, 68, 68, 0.2);
  border: 1px solid #ff4444;
  color: #ff4444;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  padding: 0;
  
  @media (min-width: 768px) {
    width: 20px;
    height: 20px;
    border-radius: 4px;
  }
  
  svg {
    font-size: 10px;
    
    @media (min-width: 768px) {
      font-size: 11px;
    }
    
    @media (min-width: 992px) {
      font-size: 12px;
    }
  }
  
  &:hover {
    background: rgba(255, 68, 68, 0.3);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const CartFooter = styled.div`
  padding: 10px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
  margin-top: auto;
  
  @media (min-width: 768px) {
    padding: 12px 14px;
    gap: 12px;
  }
  
  @media (min-width: 992px) {
    padding: 14px 16px;
    gap: 14px;
  }
`;

export const DiscountSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  @media (min-width: 768px) {
    gap: 10px;
  }
`;

export const DiscountLabel = styled.label`
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  
  @media (min-width: 768px) {
    font-size: 13px;
  }
  
  @media (min-width: 992px) {
    font-size: 14px;
  }
`;

export const DiscountInputWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 6px;
  align-items: center;
  
  @media (min-width: 768px) {
    gap: 8px;
  }
`;

export const DiscountTypeToggle = styled.div`
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
`;

export const DiscountTypeButton = styled.button`
  padding: 4px 8px;
  background: ${props => props.active ? 'rgba(242, 146, 5, 0.3)' : 'transparent'};
  border: none;
  color: ${props => props.active ? '#f29205' : 'rgba(255, 255, 255, 0.6)'};
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (min-width: 768px) {
    padding: 5px 9px;
    font-size: 12px;
  }
  
  @media (min-width: 992px) {
    padding: 6px 10px;
    font-size: 12px;
  }
  
  &:last-child {
    border-right: none;
  }
  
  &:hover {
    background: ${props => props.active ? 'rgba(242, 146, 5, 0.4)' : 'rgba(255, 255, 255, 0.1)'};
    color: ${props => props.active ? '#f29205' : '#ffffff'};
  }
`;

export const DiscountInput = styled.input`
  flex: 1;
  width: 100%;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Nunito', Helvetica, Sans-Serif;
  transition: all 0.3s ease;
  
  @media (min-width: 768px) {
    padding: 6px 11px;
    border-radius: 6px;
    font-size: 13px;
  }
  
  @media (min-width: 992px) {
    padding: 7px 12px;
    border-radius: 6px;
    font-size: 14px;
  }
  
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.08);
    border-color: #00d4ff;
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  &[type=number] {
    -moz-appearance: textfield;
  }
`;

export const ObservationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  @media (min-width: 768px) {
    gap: 7px;
    padding-bottom: 10px;
  }
`;

export const ObservationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ObservationLabel = styled.label`
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  
  @media (min-width: 768px) {
    font-size: 12px;
  }
  
  @media (min-width: 992px) {
    font-size: 13px;
  }
`;

export const ObservationToggleSection = styled.div`
`;

export const ObservationToggleButton = styled.button`
  background: transparent;
  border: 1px dashed rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.6);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  justify-content: center;
  
  @media (min-width: 768px) {
    padding: 5px 9px;
    border-radius: 5px;
    font-size: 11px;
    gap: 5px;
  }
  
  @media (min-width: 992px) {
    padding: 5px 10px;
    font-size: 12px;
  }
  
  svg {
    font-size: 9px;
    
    @media (min-width: 768px) {
      font-size: 10px;
    }
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.5);
    color: #ffffff;
  }
`;

export const ObservationTextarea = styled.textarea`
  width: 100%;
  padding: 5px 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  color: #ffffff;
  font-size: 11px;
  font-family: 'Nunito', Helvetica, Sans-Serif;
  resize: vertical;
  min-height: 35px;
  transition: all 0.3s ease;
  
  @media (min-width: 768px) {
    padding: 6px 9px;
    border-radius: 6px;
    font-size: 12px;
    min-height: 40px;
  }
  
  @media (min-width: 992px) {
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    min-height: 42px;
  }
  
  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.08);
    border-color: #00d4ff;
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

export const TotalsSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.total ? '6px 0' : '3px 0'};
  border-top: ${props => props.total ? '2px solid rgba(242, 146, 5, 0.3)' : 'none'};
  margin-top: ${props => props.total ? '4px' : '0'};
  
  @media (min-width: 768px) {
    padding: ${props => props.total ? '7px 0' : '4px 0'};
    margin-top: ${props => props.total ? '5px' : '0'};
  }
  
  @media (min-width: 992px) {
    padding: ${props => props.total ? '8px 0' : '5px 0'};
    margin-top: ${props => props.total ? '6px' : '0'};
  }
`;

export const TotalLabel = styled.span`
  color: ${props => props.total ? '#ffffff' : '#b0b0b0'};
  font-size: ${props => props.total ? '14px' : '12px'};
  font-weight: ${props => props.total ? '700' : '500'};
  
  @media (min-width: 768px) {
    font-size: ${props => props.total ? '15px' : '13px'};
  }
  
  @media (min-width: 992px) {
    font-size: ${props => props.total ? '16px' : '14px'};
  }
`;

export const TotalValue = styled.span`
  color: ${props => {
    if (props.discount) return '#00d4ff';
    if (props.total) return '#f29205';
    return '#ffffff';
  }};
  font-size: ${props => props.total ? '16px' : '12px'};
  font-weight: 700;
  text-shadow: ${props => props.total ? '0 0 10px rgba(242, 146, 5, 0.3)' : 'none'};
  
  @media (min-width: 768px) {
    font-size: ${props => props.total ? '17px' : '13px'};
  }
  
  @media (min-width: 992px) {
    font-size: ${props => props.total ? '18px' : '14px'};
  }
  
  @media (min-width: 1400px) {
    font-size: ${props => props.total ? '20px' : '14px'};
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 5px;
  
  @media (min-width: 576px) {
    gap: 10px;
  }
  
  @media (min-width: 768px) {
    gap: 12px;
  }
  
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const ActionButton = styled.button`
  flex: 1;
  min-width: 0;
  padding: 8px 10px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: none;
  white-space: nowrap;
  
  @media (min-width: 576px) {
    padding: 9px 12px;
    font-size: 12px;
    gap: 6px;
  }
  
  @media (min-width: 768px) {
    padding: 10px 14px;
    border-radius: 7px;
    font-size: 13px;
    gap: 6px;
  }
  
  @media (min-width: 992px) {
    padding: 11px 16px;
    border-radius: 8px;
    font-size: 14px;
    gap: 7px;
  }
  
  @media (min-width: 1200px) {
    padding: 12px 18px;
    font-size: 14px;
    gap: 8px;
  }
  
  @media (min-width: 1400px) {
    padding: 14px 20px;
    border-radius: 9px;
    font-size: 15px;
    gap: 8px;
  }
  
  ${props => props.cancel ? `
    background: rgba(255, 68, 68, 0.2);
    border: 2px solid #ff4444;
    color: #ff4444;
    
    &:hover {
      background: rgba(255, 68, 68, 0.3);
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(255, 68, 68, 0.3);
    }
  ` : props.primary ? `
    background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
    color: #ffffff;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(242, 146, 5, 0.4);
    }
  ` : ''}
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
  
  svg {
    font-size: 12px;
    flex-shrink: 0;
    
    @media (min-width: 576px) {
      font-size: 13px;
    }
    
    @media (min-width: 768px) {
      font-size: 14px;
    }
    
    @media (min-width: 992px) {
      font-size: 15px;
    }
    
    @media (min-width: 1200px) {
      font-size: 16px;
    }
    
    @media (min-width: 1400px) {
      font-size: 17px;
    }
  }
`;

export const EmptyCartMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #b0b0b0;
  
  i {
    font-size: 64px;
    color: rgba(255, 255, 255, 0.2);
    margin-bottom: 16px;
  }
  
  p {
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }
  
  span {
    color: #b0b0b0;
    font-size: 14px;
  }
`;

export const EmptyProductsMessage = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #b0b0b0;
  
  i {
    font-size: 64px;
    color: rgba(255, 255, 255, 0.2);
    margin-bottom: 16px;
  }
  
  p {
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px 0;
  }
  
  span {
    color: #b0b0b0;
    font-size: 14px;
  }
`;

// Reexportar FormWrapper compartilhado
export { FormWrapper };

